import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesGeneralTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-general-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
};
